<template>
  <div id="FAQs">
    <section class="about-member" style="text-align: center">
      <div class="info-container">
        <h1>Questions and Answers</h1>
        <div class="faq" v-for="(faq, index) in content" :key="index">
          <h3 class="question" style="text-align: left">{{ faq.field_question[0].value }}</h3>
          <p class="answer" style="text-align: left">{{ faq.field_answer[0].value }}</p>
        </div>
      </div>
    </section>

    <app-featured-images></app-featured-images>
  </div>
</template>

<script>
import FeaturedImages from '../components/blocks/Featured-Images.vue'

export default {
  data() {
    return {
      content: [],
      content: this.getContent()
    }
  },
  components: {
    'app-featured-images': FeaturedImages
  },
  methods: {
    getContent() {
      this.$http.get("https://" + window.location.host + "/bonnyoaks/api/faqs?_format=json").then(response => {
        this.content = response.body;
      }, response => {
        console.log("Error fetching data from URL!");
      });
    }
  }
}
</script>

